export default __webpack_public_path__ + "static/media/social-facebook.a070572b.svg";